module.exports = __webpack_public_path__ + "static/media/severe.fdf79e2a.png";